import { SxProps, TableHead, useTheme } from "@mui/material"
import { RPMTableHeaderRow } from "../../shared/table/RPMTableHeaderRow"
import { RPMTableHeaderCell } from "../../shared/table/RPMTableHeaderCell"

export const ConfigurationsListHeader = () => {

    const theme = useTheme();

    const cellProps: SxProps = { backgroundColor: theme.palette.grey[200] };

    return (
        <TableHead>
            <RPMTableHeaderRow sx={{height:'50px'}}>
                <RPMTableHeaderCell sx={cellProps}></RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Category</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Description</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Sport Code</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>Country</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>EP Display</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>EP Distribute</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>BP Display</RPMTableHeaderCell>
                <RPMTableHeaderCell sx={cellProps}>BP Distribute</RPMTableHeaderCell>
            </RPMTableHeaderRow>
        </TableHead>
    )
}
